import { Directive, Input, TemplateRef } from '@angular/core';

@Directive({
  selector: '[columnTemplate]',
})
export class ColumnTemplateDirective {
  @Input()
  field!: string;
  constructor(public template: TemplateRef<any>) {}
}
